import jQuery from 'jquery';
import moment from 'moment';

// webpack resolves every `$` in its own modules through ProvidePlugin, and jQuery's UMD takes the
// CommonJS branch here (`factory(global, true)`), so it never publishes itself on `window`.
// Exposing it explicitly lets the importmap controllers reuse THIS instance instead of pinning a
// second copy: select2, daterangepicker and every other plugin registered by the bundle live on
// it, and `$.data`/event namespaces stay shared. The bundle is a blocking script while the
// importmap is a deferred module, so this always runs first.
window.jQuery = window.$ = jQuery;
window.moment = moment;

import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/tab';
import "flowbite/dist/flowbite.turbo.js";
import 'hammerjs';
import "@hotwired/turbo-rails";
import ButtonConfirmation from './src/admin/components/confirmations';
import tippy, { followCursor } from 'tippy.js';
import 'controllers';
import './src/admin';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

function load() {
	document.querySelectorAll('[data-tippy-content]').forEach(($el) => {
		let isFollowCursor = !!$el.dataset.tippyFollowCursor ? $el.dataset.tippyFollowCursor === 'true' : true;

		let tippyProperty = {
			allowHTML: true,
			animation: 'scale',
			interactive: true,
			duration: [100, 0],
			delay: [500, 0],
			theme: 'light',
			arrow: false,
			appendTo: document.body,
			placement: $el.dataset.tippyPlacement || 'top'
		};

		if (isFollowCursor) {
			tippyProperty = Object.assign(tippyProperty, {
				followCursor: isFollowCursor,
				followCursor: (isFollowCursor ? 'horizontal' : null),
				plugins: (isFollowCursor ? [followCursor] : null),
			});
		}

		if (!$el._tippy)
			tippy($el, tippyProperty);
	});

	ButtonConfirmation.init();

	$('.modal.modal-expand').on('hidden.bs.modal', () => {
		setTimeout(() => {
			document.querySelector('body').style.padding = '0px';
		}, 150);
	});

	$('.select2').on('select2:select', function () {
		let event = new Event('change', { bubbles: true }) // fire a native event
		this.dispatchEvent(event);
	});
}

document.addEventListener("turbo:before-visit", () => {
	$('.modal').modal('hide');
});

// `modal('hide')` above only drops the class: the markup stays inside the modal frame and Turbo
// snapshots it, selected <option>s included (its clone() copies <select> state on purpose). On a
// restoration visit the turbo-modal controller would then reopen that stale, filled-in modal.
// Empty the frames and clear Bootstrap's leftovers on <body> before the snapshot is taken.
document.addEventListener("turbo:before-cache", () => {
	// Only the layout placeholders, which sit directly under <body>. A page that renders itself
	// into the modal brings its own frame nested in the content area (content_for
	// :page_provides_modal_frame) — emptying that one would cache a blank page.
	document.querySelectorAll('body > turbo-frame#turbo-modal, body > turbo-frame#turbo-modal-secondary').forEach((frame) => {
		frame.removeAttribute('src');
		frame.innerHTML = '';
	});

	document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
	document.body.classList.remove('modal-open');
	document.body.style.removeProperty('padding-right');
	delete document.body.dataset.openModals;
});
document.addEventListener("turbo:frame-load", load);
document.addEventListener("turbo:load", load);

// SweetAlert
import Swal from "sweetalert2";

window.SweetAlert = Swal.mixin({
  showClass: { backdrop: 'swal2-noanimation', popup: '', },
  hideClass: { popup: '' },
  customClass: {
    cancelButton: 'btn btn-gray-primary',
    confirmButton: 'btn btn-primary',
    denyButton: 'btn btn-gray-primary',
    actions: 'flex justify-content-center items-center gap-2 flex-wrap',
  },
  buttonsStyling: false,
});
